import React, { useContext } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { DRAGGER_CONTENT, EMPLOYEE_PAGE_CONTENT } from '../../../constants/employeeData'
import { AppDispatchContext } from '../../../utils/contexts'
import { EmployeeDataHoc } from '../../../utils/hocs'
import { UserAlert } from '../../common/atoms/alerts'
import { UploadCard } from '../../common/organisms'

const MemberUpload = () => {
  const history = useHistory()
  const location = useLocation()
  const PageContent = location.state?.text === 're-upload' ? 're_upload_stepathon_member_upload'  : 'stepathon_member_bulk_uploader'
  const DraggerContent = location.state?.text === 're-upload' ? 're_upload_stepathon_member_content'  : 'stepathon_member_bulk_register'
  const CONTENT  = EMPLOYEE_PAGE_CONTENT[PageContent]
  const dispatch = useContext(AppDispatchContext)


  const uploadRequest = (info) => {
    dispatch({ type: 'employee_data', file: info.file })
    sessionStorage.setItem('stepathon_id', location.state.stepathon_id)
    history.push(`/employee-data/file-upload?of=${PageContent}`)
  }
  return (
    <>
      <EmployeeDataHoc
        title={CONTENT['title']}
        breadcrumb={[
          { text: 'Engagement', link: '/stepathon' },
          { text: 'Stepathon', link: '/stepathon' },
          CONTENT['breadcrumb']
        ]}
        close={() => history.goBack()}
      >
        { location.state?.text === 're-upload' &&
          <UserAlert
          para={location.state?.text === 're-upload' ? 'Uploading a new excel will overwrite the previous teams data' : ''}
          paraClasses='text-base pt-0.5 text-gray-700'
          icon='yellow'
          imgClasses='h-5 w-5'
          classes='border border-yellow-200 p-4 mt-6'
        />}
        <UploadCard
          CONTENT={DRAGGER_CONTENT[DraggerContent]}
          uploadRequest={uploadRequest}
          classes={location.state?.text === 're-upload' ? 'mt-6' : 'mt-8'}
          listHeading={["Download CSV File", "Download XLSX File"]}
        />
      </EmployeeDataHoc>
    </>
  )
}

export default MemberUpload
